import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Stack } from "@mui/material";
import PendingEvent from "./pendingEvent";
import BookedEvent from "./bookedEvent";
import { useState, useEffect } from "react";
import { GetAll } from "../../../util/request/getAll";
import BookingCalendar from "./bookingCalendar";
import FieldTripEvent from "./fieldTripEvent";
import HistoryEvent from "./historyEvent";
// import ChangeDateTime from "./chageDateTime";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

export default function BookingMain() {
  const [value, setValue] = useState(0);
  const [pendingBookings, setPendingBookings] = useState([]);
  const [completedBookings, setCompletedBookings] = useState([]);
  const [fieldTripBookings, setFieldTripBookings] = useState([]);
  const [bookingHistory, setBookingHistory] = useState([]);

  const [refresh, setRefresh] = useState(true);

  const RefreshHandler = () => {
    setRefresh((prev) => !prev);
  };

  useEffect(() => {
    async function runFunc0() {
      const response = await GetAll({
        subLink: `booking?booking_status=booked&non_refund_deposite=0
          `,
      });

      if (response.data) {
        console.log(response.data);
        setPendingBookings(response.data.data);
      }
    }

    async function runFunc1() {
      const response = await GetAll({
        subLink: `booking?booking_status=booked
          `,
      });

      if (response.data) {
        console.log(response.data);
        setCompletedBookings(response.data.data);
      }
    }
    async function runFunc2() {
      const response = await GetAll({
        subLink: `fieldtrip?booking_status=booked
          `,
      });
      console.log(response.data);

      if (response.data) {
        console.log(response.data);
        setFieldTripBookings(response.data.data);
      }
    }
    async function runFunc3() {
      const response = await GetAll({
        subLink: `booking?booking_status=completed
          `,
      });

      if (response.data) {
        console.log(response.data);
        setBookingHistory(response.data.data);
      }
    }
    // if (value === 0) {
    //   runFunc0();
    // }

    if (value === 0) {
      runFunc1();
    }
    if (value === 2) {
      runFunc2();
    }
    if (value === 3) {
      runFunc3();
    }
    if (value === 4) {
      runFunc0();
    }
  }, [value, refresh]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Stack
      justifyContent="flex-start"
      direction="row"
      sx={{
        flexGrow: 1,
        bgcolor: "background.paper",
        width: "100%",
        minWidth: "804px",
        // overflowX: true,
      }}
    >
      {/* <ChangeDateTime /> */}
      <Stack
        alignContent="center"
        // direction="row"
        sx={{
          flexGrow: 1,
          bgcolor: "background.paper",
          width: "100%",
          // minWidth: "900px",
          // overflowX: true,
        }}
      >
        <Tabs
          TabIndicatorProps={
            {
              // style: {
              //   backgroundColor: "#8525da",
              //   // height: "40px",
              //   width: "8px",
              //   borderRadius: "40px",
              // },
            }
          }
          // orientation="vertical"
          variant="standard"
          value={value}
          onChange={handleChange}
          sx={{
            display: "flex",
            flexDirection: "row",
            // bgcolor: "#b69bce2c",
            // alignItems: "center",
            // borderRight: 1,
            borderColor: "divider",
            // width: "100px",
            ".Mui-selected": {
              color: "#8525da", // Sets the text color of the selected tab
              fontWeight: "650", // Sets the font weight of the selected tab
              backgroundColor: "#f3e8ff", // Sets the background color of the selected tab
              borderRadius: "20px", // Sets the border radius of the selected tab
            },
            "& .MuiTabs-indicator": { display: "none" },
          }}
        >
          {/* <Tab label="Pending" {...a11yProps(0)} /> */}

          <Tab label="Booked" sx={{ fontSize: "12px" }} {...a11yProps(0)} />
          <Tab label="Calendar" sx={{ fontSize: "12px" }} {...a11yProps(1)} />
          <Tab
            label="Field T"
            sx={{
              fontSize: "12px",
            }}
            {...a11yProps(2)}
          />
          <Tab label="archive" sx={{ fontSize: "12px" }} {...a11yProps(3)} />
          <Tab label="Pending" sx={{ fontSize: "12px" }} {...a11yProps(4)} />
        </Tabs>

        <TabPanel value={value} index={0}>
          <BookedEvent
            completedBookings={completedBookings}
            reFreshData={RefreshHandler}
          />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <BookingCalendar
            bookingHistory={bookingHistory}
            reFreshData={RefreshHandler}
          />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <FieldTripEvent
            fieldTripBookings={fieldTripBookings}
            reFreshData={RefreshHandler}
          />
        </TabPanel>
        <TabPanel value={value} index={3}>
          <HistoryEvent
            completedBookings={bookingHistory}
            reFreshData={RefreshHandler}
          />
        </TabPanel>
        <TabPanel value={value} index={4}>
          <PendingEvent
            pendingBookings={pendingBookings}
            reFreshData={RefreshHandler}
          />
        </TabPanel>
      </Stack>
    </Stack>
  );
}

// import BookingModal from "./bookModal";

// const BookingMain = () => {
//   return (
//     <>
//       <BookingModal></BookingModal>
//     </>
//   );
// };

// export default BookingMain;
